import React, { useEffect } from "react";
import Consumer from "../models/Consumer";
import Page from "../models/Page";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import ConsumerView from "./ConsumerView";
import { PagePrintInfo } from "../models/PagePrintInfo";
import { RDiv } from "../components/renderPrimitives/RDiv";
import Button from "../models/Button";

export default function ConsumersView(props: { page: Page; mainPage: Page; print?: PagePrintInfo }) {
  const { page, mainPage, print } = props;

  useOnChangeWatcher(page.consumers);
  useOnChangeWatcher(page.buttons);

  let items: Array<Consumer | Button> = page.consumers.asArray();
  if (!state.settings.diagnosticMode) {
    items = items.concat(page.buttons.asArray());
  }

  const children: any = [];
  items.forEach((consumerOrButton) => {
    children.push(
      <ConsumerView
        key={consumerOrButton.id}
        consumerOrButton={consumerOrButton}
        mainPage={mainPage}
        page={page}
        print={print}
      />,
    );
  });

  console.log("redraw ConsumersView");

  return (
    <RDiv
      style={{
        position: "absolute",
        left: "0px",
        top: "0px",
        width: "100%",
        height: "100%",
        pointerEvents: "none",
      }}
    >
      {children}
    </RDiv>
  );
}
